import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import config from "@/lib/config";
import { RESTDataSource } from "@apollo/datasource-rest";
import { v4 as uuidv4 } from "uuid";

var SessionManager = /*#__PURE__*/function (_RESTDataSource) {
  _inherits(SessionManager, _RESTDataSource);

  var _super = _createSuper(SessionManager);

  function SessionManager(options) {
    var _this;

    _classCallCheck(this, SessionManager);

    _this = _super.call(this, options);

    _defineProperty(_assertThisInitialized(_this), "baseURL", config.api.sessionManagerURL);

    _this.context = options;
    return _this;
  }

  _createClass(SessionManager, [{
    key: "willSendRequest",
    value: function willSendRequest(_path, request) {
      var _this$context$req;

      if ((_this$context$req = this.context.req) !== null && _this$context$req !== void 0 && _this$context$req.userToken) {
        var _this$context$req$use = this.context.req.userToken,
            id = _this$context$req$use.id,
            accessToken = _this$context$req$use.accessToken;
        request.headers["X-Token-Id"] = id;
        request.headers["Authorization"] = "Bearer ".concat(accessToken);
      }

      var requestId = uuidv4();
      request.headers["X-Spoox-Web-Session-Request-Id"] = requestId;
      var userId = request.headers["X-User-Id"];
      console.log("[".concat(requestId, "][Session][REQUEST INFO] Method: ").concat(request.method, ", Path: ").concat(_path, ", UserId: ").concat(userId));
    }
  }, {
    key: "didReceiveResponse",
    value: function () {
      var _didReceiveResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response, request) {
        var requestId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestId = request.headers["X-Spoox-Web-Session-Request-Id"];
                console.log("[".concat(requestId, "][Session][RESPONSE INFO] Status: ").concat(response.status));
                return _context.abrupt("return", _get(_getPrototypeOf(SessionManager.prototype), "didReceiveResponse", this).call(this, response, request));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function didReceiveResponse(_x, _x2) {
        return _didReceiveResponse.apply(this, arguments);
      }

      return didReceiveResponse;
    }()
  }, {
    key: "pinActivate",
    value: function () {
      var _pinActivate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function pinActivate() {
        return _pinActivate.apply(this, arguments);
      }

      return pinActivate;
    }()
  }, {
    key: "tokenRefresh",
    value: function () {
      var _tokenRefresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$context$req2;

        var refreshToken, params, ret;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!((_this$context$req2 = this.context.req) !== null && _this$context$req2 !== void 0 && _this$context$req2.userToken)) {
                  _context3.next = 7;
                  break;
                }

                refreshToken = this.context.req.userToken.refreshToken;
                params = {
                  refresh_token: refreshToken
                };
                _context3.next = 5;
                return this.post("/token/refresh", {
                  body: params
                });

              case 5:
                ret = _context3.sent;
                return _context3.abrupt("return", ret);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function tokenRefresh() {
        return _tokenRefresh.apply(this, arguments);
      }

      return tokenRefresh;
    }()
  }, {
    key: "tokenCheck",
    value: function () {
      var _tokenCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.post("/token/check"));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function tokenCheck() {
        return _tokenCheck.apply(this, arguments);
      }

      return tokenCheck;
    }()
  }, {
    key: "tokenDelete",
    value: function () {
      var _tokenDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.post("/token/delete"));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function tokenDelete() {
        return _tokenDelete.apply(this, arguments);
      }

      return tokenDelete;
    }()
  }, {
    key: "tokenDeleteOther",
    value: function () {
      var _tokenDeleteOther = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.post("/token/delete-other"));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function tokenDeleteOther() {
        return _tokenDeleteOther.apply(this, arguments);
      }

      return tokenDeleteOther;
    }()
  }, {
    key: "onetimeToken",
    value: function () {
      var _onetimeToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.post("/ontime-token/publish"));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onetimeToken() {
        return _onetimeToken.apply(this, arguments);
      }

      return onetimeToken;
    }()
  }]);

  return SessionManager;
}(RESTDataSource);

export default SessionManager;